import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = ["onClick"]

import { computed, withDefaults } from 'vue'

interface Props {
  disabled?: boolean,
  neighboursCount?: number,
  page?: number,
  perPage?: number,
  totalCount: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppPagination',
  props: {
    disabled: { type: Boolean, default: false },
    neighboursCount: { default: 5 },
    page: { default: 1 },
    perPage: { default: 10 },
    totalCount: null
  },
  emits: ["pageChanged"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'pageChanged', pagination: { page: number, per_page: number }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { disabled: boolean, neighboursCount: number, page: number, perPage: number, totalCount: number };



const pages = computed(() => buildPages(props.page, props.neighboursCount, props.perPage, props.totalCount))



function onPageClick (pageNumber: number): void {
  emit('pageChanged', { page: pageNumber, per_page: props.perPage })
}

function buildPages (currentPage: number, neighboursCount: number, itemsPerPage: number, itemsTotalCount: number): number[] {
  const totalPageCount = Math.ceil(itemsTotalCount / itemsPerPage)

  const _pages = []

  let skipNull = false

  for (let page = 1; page <= totalPageCount; ++page) {
    if (page === 1 || page === totalPageCount) {
      _pages.push(page)
      continue
    }

    if (Math.abs(page - currentPage) <= neighboursCount) {
      _pages.push(page)
      skipNull = false
      continue
    }

    if (!skipNull) {
      _pages.push(null)
    }
    skipNull = true
  }

  if (_pages.length === 1) {
    return []
  }

  return _pages
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass({'cursor-progress': __props.disabled})
  }, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pages), (pageNumber) => {
        return (_openBlock(), _createElementBlock("li", {
          key: pageNumber,
          class: _normalizeClass([{disabled: !pageNumber || __props.disabled, active: pageNumber === props.page}, "page-item"])
        }, [
          _createElementVNode("span", {
            class: "page-link cursor-pointer",
            onClick: ($event: any) => (onPageClick(pageNumber))
          }, _toDisplayString(pageNumber || '...'), 9, _hoisted_2)
        ], 2))
      }), 128))
    ])
  ], 2))
}
}

})